import React from "react";
import { Container, Typography, Button, Box } from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";

const NoAccess = () => {

  return (
    <Container maxWidth="sm">
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        
        textAlign="center"
      >
        <LockOutlinedIcon sx={{ fontSize: 80, color: "error.main", mb: 2 }} />
        <Typography variant="h4" fontWeight="bold">
          Access Denied
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mt: 1, mb: 3 }}>
          You do not have permission to view this page.
        </Typography>
       
      </Box>
    </Container>
  );
};

export default NoAccess;
